'use client';

/**
 * Hosted UI OAuth callback handoff (wiki/AUTH-DESIGN.md "Hosted UI + Google
 * sign-in"): the registered `callback_urls` are bare origins with no path
 * (`https://dev.simbay.app`, `http://localhost:3100`), so Cognito always
 * redirects back to this marketing root. This component detects that
 * redirect and hands the query string off to `/train`, where the real
 * exchange-and-link logic lives (lib/auth is (app)-only and must never be
 * imported here — see the no-restricted-imports wall in eslint.config.mjs).
 * Renders nothing on a normal landing-page visit.
 */
import { useEffect } from 'react';

export default function OAuthHandoff() {
  useEffect(() => {
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const isOAuthReturn =
      (params.has('code') || params.has('error')) && params.has('state');
    if (isOAuthReturn) {
      window.location.replace(`/train${search}`);
    }
  }, []);

  return null;
}
